/**
 * Admin middleware - ochrana admin tras
 * Pouze uživatelé s Admin rolí mohou přistupovat k admin sekcím
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const user = useSupabaseUser()
  
  // Pokud uživatel není přihlášen, přesměruj na login
  if (!user.value) {
    throw createError({
      statusCode: 401,
      statusMessage: 'Authentication required'
    })
  }

  // Použijeme userRole composable pro kontrolu oprávnění
  const { canAccessAdmin, ensureRoleLoaded } = useUserRole()

  // Počkáme na načtení role. `isLoading` nestačí: je false i v okamžiku, kdy
  // se role teprve začíná načítat, takže kontrola níže běžela naprázdno.
  await ensureRoleLoaded()

  // Kontrola admin oprávnění
  if (!canAccessAdmin.value) {
    throw createError({
      statusCode: 403,
      statusMessage: 'Access denied - Admin privileges required'
    })
  }
})